import { useCallback } from "react";
import { useAuth } from "@/hooks/use-auth";

export function useAnalytics() {
  const { user } = useAuth();

  const track = useCallback((event: string, opts?: { screen?: string; metadata?: Record<string, unknown>; town?: string }) => {
    fetch("/api/analytics/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ event, screen: opts?.screen, metadata: opts?.metadata, town: opts?.town, platform: "web" }),
    }).catch(() => {});
  }, [user]);

  return { track };
}
